import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import HighlightText from "./components/HighlightText";

export default function SpendeSeite() {
  useEffect(() => window.scrollTo(0, 0), []);

  return (
    <div id="spende-wrapper" style={{ paddingTop: "8rem", minHeight: "100vh" }}>
      <Helmet>
        <title>Spenden | Limbach für Alle</title>
      </Helmet>

      <div className="container">
        <div className="row text-center">
          <div className="col-sm-12">
            <h1>
              Deine <HighlightText text="Spende" /> macht den Unterschied!
            </h1>
            <hr style={{ color: "var(--primary-color)" }} />
          </div>
        </div>

        <div className="row mt-5" style={{ textAlign: "justify" }}>
          <div className="col-sm-12">
            <p>
              Mit eurer Hilfe können wir weiterhin unsere vielfältigen Projekte und Initiativen 
              vorantreiben, die Solidarität und Gemeinschaft schaffen. Egal, ob es um 
              <HighlightText text=" Bildungsangebote" />, kulturelle Veranstaltungen, Konzerte 
              oder <HighlightText text="soziale Unterstützung" /> geht – jede Spende hilft, Limbach 
              zu einem vielseitigen und offenen Ort zu gestalten. Gemeinsam können wir mehr erreichen! 
            </p>
          </div>

          {/* --- Betterplace-Spendenformular: eingebettetes iFrame --- */}
          <div className="col-sm-12 mt-4">
            {/* Hinweis für Banküberweisung */}
            <div 
              className="mb-4" 
              style={{ 
                backgroundColor: "rgba(138, 43, 226, 0.05)", 
                border: "2px solid var(--primary-color)",
                borderRadius: "10px",
                padding: "1.5rem",
                fontFamily: "Roboto",
                fontSize: "1.4rem"
              }}
            >
              <strong style={{ color: "var(--primary-color)" }}>Hinweis zur Banküberweisung:</strong> Wenn Sie per Banküberweisung 
              spenden möchten, öffnen Sie bitte das Formular direkt auf Betterplace:{" "}
              <a
                href="https://www.betterplace.org/de/projects/159678/donations/new"
                target="_blank"
                rel="noopener noreferrer"
                style={{ 
                  color: "var(--primary-color)", 
                  fontWeight: "bold", 
                  textDecoration: "underline" 
                }}
              >
                Hier klicken für direkten Zugang
              </a>
            </div>

            {/* iFrame für Online-Zahlungen */}
            <div style={{ width: "100%", }}>
              <iframe
                src="https://www.betterplace.org/de/projects/159678/donations/new?embed=1"
                title="Betterplace Spendenformular"
                width="100%"
                height= "800"
                frameBorder="0"
                scrolling="auto"
                allow="payment *; clipboard-read; clipboard-write"
                referrerPolicy="strict-origin-when-cross-origin"
                style={{
                  display: "block",
                  margin: "0 auto",
                  border: "none",
                }}
              />
              <noscript>
                Bitte JavaScript aktivieren, um das Spendenformular zu laden. 
                Alternativ:{" "}
                <a
                  href="https://www.betterplace.org/de/projects/159678/donations/new"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  direkt zu betterplace.org
                </a>
              </noscript>
            </div>
          </div>

          <div className="row mt-5" style={{ textAlign: "justify" }}>
            <div className="col-sm-12">
              <p>
                Auch wenn Engagement und Gemeinschaft nicht mit Geld aufzuwiegen ist, 
                macht es doch vieles einfacher. Jede Spende hilft, unsere Projekte langfristig 
                voranzutreiben und abzusichern und gibt uns Sicherheit bei der Planung. 
                Selbstverständlich können wir auch eine <HighlightText text="Spendenquittung" /> erstellen.
              </p>
              <p className="pb-5">Wir bedanken uns bei allen Unterstützer*innen!</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
